
<template>
  <div class="order-page-header">
    <div class="container-md">
      <div class="brand-box">
        <div class="index-logo" @click="clickLogo"></div>
        <div class="separate"></div>
        <div class="page-title">{{activeTab.name}}</div>
      </div>
      <div class="tab-box">
        <div class="tab-item" @click="jumpStep(tab)" :class="[classArr[tab.status]]" v-for="(tab, index) in tabs" :key="index">
          <img class="icon" :src="tab.iconMap[tab.status]" alt="">
          <div class="tab-name">{{tab.name}}</div>
        </div>
      </div>
      <div class="right-info">
        <div class="peer-info" @click="gotoAccount">
          <img class="peer-icon" :src="User.peer && User.peer.logo ? User.peer.logo: 'https://o.666visa.cn/static/ssqpeer/order/default-avatar.png'" alt="">
          <div class="account-name">{{User.name ? User.name : '未知用户'}}</div>
        </div>
        <div class="separate"></div>
        <div class="order-box" @click="gotoOrder">
          <div class="order-label">我的订单</div>
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/order-list-icon.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-nested-ternary */
import User from '../../../libs/user';

export default {
  name: 'ordering-step',
  props: {
    // 订单信息
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 当前页面对应的订单状态
    currentPageOrderStatus: {
      type: Number,
      required: true,
      default: 0,
    },

    // 禁用进度条
    disabled: {
      type: Boolean,
      default: false,
    },
    allowLeave: {
      type: Boolean,
    },
  },
  data() {
    return {
      User,
      classArr: ['', 'done', 'active'], // status 0 未完成 1已完成 2当前选中,
    };
  },
  computed: {
    tabs() {
      // status 0 未完成 1已完成 2当前选中,
      const tabs = [];
      const order = this.order;
      if (!order) {
        return tabs;
      }

      if (order.offline === 1) {
        tabs.push({
          name: '生成订单',
          orderStatus: 1,
          url: '',
          status: 0,
          iconMap: {
            0: 'https://o.666visa.cn/static/ssqpeer/order/step-generate.png',
          },
        });
      } else {
        tabs.push({
          name: '资料上传',
          orderStatus: 1,
          routeConfig: {
            name: 'waittingForUpload',
            params: {
              oid: order.user_order_id,
            },
          },
          status: this.currentPageOrderStatus === 1 ? 2 : 1,
          iconMap: {
            1: 'https://o.666visa.cn/static/ssqpeer/order/step-upload-done.png',
            2: 'https://o.666visa.cn/static/ssqpeer/order/step-upload-active.png',
          },
        });
      }

      // 如果是面试面递订单
      if (order.need_interview > 0 || order.need_delivery > 0) {
        tabs.push({
          name: '赴馆日期',
          orderStatus: 10,
          routeConfig: {
            name: 'waittingForChooseInterviewTime',
            params: {
              oid: order.user_order_id,
            },
          },
          status: this.currentPageOrderStatus === 10 ? 2 : [1, 2].indexOf(order.order_status) > -1 ? 0 : 1,
          iconMap: {
            0: 'https://o.666visa.cn/static/ssqpeer/order/step-interview.png',
            1: 'https://o.666visa.cn/static/ssqpeer/order/step-interview-done.png',
            2: 'https://o.666visa.cn/static/ssqpeer/order/step-interview-active.png',
          },
        });
      }

      tabs.push({
        name: '确认订单',
        className: '',
        orderStatus: 3,
        routeConfig: {
          name: 'orderComfirm',
          params: {
            oid: order.user_order_id,
          },
        },
        status: this.currentPageOrderStatus === 3 ? 2 : [1, 2, 10].indexOf(order.order_status) > -1 ? 0 : 1,
        iconMap: {
          0: 'https://o.666visa.cn/static/ssqpeer/order/step-confirm.png',
          1: 'https://o.666visa.cn/static/ssqpeer/order/step-confirm-done.png',
          2: 'https://o.666visa.cn/static/ssqpeer/order/step-confirm-active.png',
        },
      });
      return tabs;
    },
    // 当前选中的tab
    activeTab() {
      return this.tabs.find(item => item.status === 2);
    },
  },
  watch: {
  },
  methods: {
    jumpStep(tab) {
      if (tab.orderStatus === this.currentPageOrderStatus) {
        return;
      }
      // 这个时候，不拦截跳转
      this.$emit('update:allowLeave', true);
      if (tab.routeConfig) this.$router.push(tab.routeConfig);
    },
    gotoOrder() {
      this.$router.push({ name: 'orders' });
    },
    // 到我的账户
    gotoAccount() {
      if (User.is_palmyou) {
        if (User.is_admin) {
          this.$router.push({ name: 'staff' });
        } else {
          this.$router.push({ name: 'address' });
        }
      } else {
        this.$router.push({ name: 'profile' });
      }
    },
    clickLogo() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="less" scoped>
.order-page-header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  z-index: 101;
  color: #2F333D;
  border-bottom: 1px solid #E9EEF2;
  background: #fff;
  line-height: 1;
  .container-md{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .brand-box{
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      display: flex;
      align-items: center;
      .index-logo{
        background: url(../../../assets/imgs/common/header-logo-blue.png) no-repeat center / 100% 100%;
        width: 120px;
        height:38px;
        cursor: pointer;
      }
      .separate{
        width: 1px;
        height: 21px;
        background: #DEE2E6;
        margin: 0 16px;
      }
      .page-title{
        color: #2F333D;
        font-size: 24px;
        font-weight: 600;
      }
    }
    .tab-box{
      display: flex;
      align-items: center;
      .tab-item{
        display: flex;
        align-items: center;
        margin-right: 60px;
        position: relative;
        &::after{
          content: "";
          width: 31px;
          height: 6px;
          background: url(https://o.666visa.cn/static/ssqpeer/order/step-right.png) no-repeat center / 100% 100%;
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 16px;
        }
        &:last-child{
          margin-right: 0;
          &::after{
            display: none;
          }
        }
        .icon{
          width: 16px;
          height: 16px;
          margin-right: 4px;
          flex-shrink: 0;
        }
        .tab-name{
          color: #CCCCCC;
          font-size: 14px;
        }
        &.done{
          cursor: pointer;
          .tab-name{
            color: #5F666E;
          }
        }
        &.active{
          .tab-name{
            color: #599FFF;
            font-weight: 600;
          }
        }
      }
    }
    .right-info{
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      display: flex;
      align-items: center;
      .peer-info{
        display: flex;
        align-items: center;
        cursor: pointer;
        .peer-icon{
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .account-name{
          font-size: 16px;
          line-height: 24px;
          color: #2F333D;
          font-weight: 600;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .separate{
        width: 1px;
        height: 14px;
        background: #DEE2E6;
        margin: 0 16px;
      }
      .order-box{
        cursor: pointer;
        display: flex;
        align-items: center;
        .order-label{
          font-size: 16px;
          color: #2F333D;
          font-weight: 600;
        }
        .icon{
          width: 16px;
          height: 16px;
          margin-left: 4px;
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-page-header.vue